module.exports = __webpack_public_path__ + "img/logoutIconActive.1ccee2ac.svg";